import momentum from 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(momentum);

export default moment;
